// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"7ddfb10e","206":"9b22d761","606":"f39efde9","948":"47c20da1"}[chunkId] + ".chunk.js";
};